module.exports = __webpack_public_path__ + "static/media/roaming-voice.90553613.svg";